export default {
      id: "ico-twitter-usage",
      viewBox: "0 0 24 22",
      url: __webpack_public_path__ + "sprite.svg#ico-twitter",
      toString: function () {
        return this.url;
      }
    }